@if (isLoading()) {
} @else {
	<div class="min-h-screen px-4 md:px-8 pb-16 pt-32">

		<!-- Header -->
		<div class="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
			<div class="flex items-center gap-3" data-tour="header">
				<div>
					<h1 class="text-5xl lg:text-6xl text-peps-gold font-dinpro-bold uppercase">{{ 'page.marketplace.title' | translate }}</h1>
					<p class="text-base lg:text-lg font-notosans text-peps-dark-200/50 mt-1.5 max-w-md">{{ 'page.marketplace.description' | translate }}</p>
				</div>
				<!-- Rejouer le tutoriel -->
				<button
					type="button"
					class="flex items-center justify-center w-9 h-9 rounded-full bg-peps-dark-700 border border-peps-dark-500 hover:border-peps-gold text-peps-dark-200/70 hover:text-peps-gold shrink-0 cursor-pointer transition-colors"
					[title]="'page.marketplace.tutorial.replay' | translate"
					(click)="startTour()"
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="size-4 lg:size-5">
						<path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519a3 3 0 1 1 3.61 4.63c-.83.667-1.489 1.622-1.489 2.851m0 3h.008M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
					</svg>
				</button>
			</div>
			<div class="flex items-center gap-4 shrink-0">
				@if (authService.isAuthenticated()) {
					<button
						class="text-[11px] uppercase tracking-widest cursor-pointer font-dinpro-medium border border-peps-gold/30 text-peps-gold/70 hover:border-peps-gold/60 hover:text-peps-gold px-4 py-2 transition-colors duration-150"
						data-tour="sell"
						(click)="openSellModal()"
						(keydown.enter)="openSellModal()"
					>
						{{ 'page.marketplace.sell' | translate }}
					</button>
				}
			</div>
		</div>

		<!-- Tabs -->
		@if (authService.isAuthenticated()) {
			<div class="flex items-center gap-6 mb-8 border-b border-peps-dark-500" data-tour="tabs">
				<button
					class="text-xs lg:text-sm uppercase tracking-widest font-dinpro-medium pb-2.5 border-b-2 transition-colors duration-150 cursor-pointer"
					[class.text-peps-gold]="activeTab() === 'market'"
					[class.border-peps-gold]="activeTab() === 'market'"
					[class.text-peps-dark-200]="activeTab() !== 'market'"
					[class.border-transparent]="activeTab() !== 'market'"
					(click)="switchTab('market')"
					(keydown.enter)="switchTab('market')"
				>{{ 'page.marketplace.tab-market' | translate }}</button>
				<button
					class="text-xs lg:text-sm uppercase tracking-widest font-dinpro-medium pb-2.5 border-b-2 transition-colors duration-150 cursor-pointer"
					[class.text-peps-gold]="activeTab() === 'mine'"
					[class.border-peps-gold]="activeTab() === 'mine'"
					[class.text-peps-dark-200]="activeTab() !== 'mine'"
					[class.border-transparent]="activeTab() !== 'mine'"
					(click)="switchTab('mine')"
					(keydown.enter)="switchTab('mine')"
				>{{ 'page.marketplace.tab-mine' | translate }}</button>
				<button
					class="text-xs lg:text-sm uppercase tracking-widest font-dinpro-medium pb-2.5 border-b-2 transition-colors duration-150 cursor-pointer"
					[class.text-peps-gold]="activeTab() === 'history'"
					[class.border-peps-gold]="activeTab() === 'history'"
					[class.text-peps-dark-200]="activeTab() !== 'history'"
					[class.border-transparent]="activeTab() !== 'history'"
					(click)="switchTab('history')"
					(keydown.enter)="switchTab('history')"
				>{{ 'page.marketplace.tab-history' | translate }}</button>
			</div>
		}

		<!-- Content -->
		<div class="flex flex-col md:flex-row gap-6">

			<!-- Sidebar -->
			<div class="flex flex-col gap-4 md:w-56 shrink-0">

				<!-- Search -->
				<div class="relative flex items-center" data-tour="search">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
						class="absolute left-3 size-4 lg:size-5 text-peps-dark-200/30 pointer-events-none">
						<path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
					</svg>
					<input
						type="text"
						[placeholder]="'page.marketplace.search-placeholder' | translate"
						[value]="cardNameFilter()"
						(input)="onCardNameInput($event)"
						class="w-full pl-9 pr-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium uppercase tracking-wide text-peps-dark-200 placeholder:text-peps-dark-200/30 outline-none focus:border-peps-gold/40 transition-colors duration-150"
					/>
				</div>

				@if (activeTab() === 'market') {
					<!-- Sort -->
					<div class="flex flex-col gap-1" data-tour="sort">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.marketplace.sort-label' | translate }}</span>
						<button
							class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
							[style.border-color]="sortOption() === 'recent' ? '#EEC932' : 'rgba(255,255,255,0.07)'"
							[style.color]="sortOption() === 'recent' ? '#EEC932' : 'rgba(255,255,255,0.3)'"
							[style.background]="sortOption() === 'recent' ? 'rgba(238,201,50,0.12)' : 'transparent'"
							(click)="setSortOption('recent')"
							(keydown.enter)="setSortOption('recent')"
						>{{ 'page.marketplace.sort-recent' | translate }}</button>
						<button
							class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
							[style.border-color]="sortOption() === 'price-asc' ? '#EEC932' : 'rgba(255,255,255,0.07)'"
							[style.color]="sortOption() === 'price-asc' ? '#EEC932' : 'rgba(255,255,255,0.3)'"
							[style.background]="sortOption() === 'price-asc' ? 'rgba(238,201,50,0.12)' : 'transparent'"
							(click)="setSortOption('price-asc')"
							(keydown.enter)="setSortOption('price-asc')"
						>{{ 'page.marketplace.sort-price-asc' | translate }}</button>
						<button
							class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
							[style.border-color]="sortOption() === 'price-desc' ? '#EEC932' : 'rgba(255,255,255,0.07)'"
							[style.color]="sortOption() === 'price-desc' ? '#EEC932' : 'rgba(255,255,255,0.3)'"
							[style.background]="sortOption() === 'price-desc' ? 'rgba(238,201,50,0.12)' : 'transparent'"
							(click)="setSortOption('price-desc')"
							(keydown.enter)="setSortOption('price-desc')"
						>{{ 'page.marketplace.sort-price-desc' | translate }}</button>
						<button
							class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
							[style.border-color]="sortOption() === 'rating' ? '#EEC932' : 'rgba(255,255,255,0.07)'"
							[style.color]="sortOption() === 'rating' ? '#EEC932' : 'rgba(255,255,255,0.3)'"
							[style.background]="sortOption() === 'rating' ? 'rgba(238,201,50,0.12)' : 'transparent'"
							(click)="setSortOption('rating')"
							(keydown.enter)="setSortOption('rating')"
						>{{ 'page.marketplace.sort-rating' | translate }}</button>
						<button
							class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
							[style.border-color]="sortOption() === 'name' ? '#EEC932' : 'rgba(255,255,255,0.07)'"
							[style.color]="sortOption() === 'name' ? '#EEC932' : 'rgba(255,255,255,0.3)'"
							[style.background]="sortOption() === 'name' ? 'rgba(238,201,50,0.12)' : 'transparent'"
							(click)="setSortOption('name')"
							(keydown.enter)="setSortOption('name')"
						>{{ 'page.marketplace.sort-name' | translate }}</button>
					</div>

					<!-- Price range -->
					<div class="flex flex-col gap-1">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.marketplace.filter-price-label' | translate }}</span>
						<div class="flex items-center gap-2">
							<input
								type="number"
								min="0"
								[placeholder]="'page.marketplace.filter-price-min' | translate"
								[value]="minPriceFilter()"
								(input)="onMinPriceInput($event)"
								class="w-full min-w-0 px-2 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium text-peps-dark-200 placeholder:text-peps-dark-200/30 outline-none focus:border-peps-gold/40 transition-colors duration-150 tabular-nums"
							/>
							<span class="text-peps-dark-200/20 text-base lg:text-lg shrink-0">–</span>
							<input
								type="number"
								min="0"
								[placeholder]="'page.marketplace.filter-price-max' | translate"
								[value]="maxPriceFilter()"
								(input)="onMaxPriceInput($event)"
								class="w-full min-w-0 px-2 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium text-peps-dark-200 placeholder:text-peps-dark-200/30 outline-none focus:border-peps-gold/40 transition-colors duration-150 tabular-nums"
							/>
						</div>
					</div>

					<!-- Seller -->
					<div class="flex flex-col gap-1">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.marketplace.filter-seller-label' | translate }}</span>
						<select
							[value]="sellerUsernameFilter()"
							(change)="setSellerFilter($any($event.target).value)"
							class="w-full px-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium uppercase tracking-wide text-peps-dark-200 outline-none focus:border-peps-gold/40 transition-colors duration-150 cursor-pointer"
						>
							<option value="">{{ 'page.marketplace.filter-all' | translate }}</option>
							@for (seller of sellers(); track seller.id) {
								<option [value]="seller.username">{{ seller.username }}</option>
							}
						</select>
					</div>

					<div class="flex flex-col gap-1">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{'page.marketplace.filter-extension-label' | translate }}</span>
						<select
							[value]="extensionFilter()"
							(change)="setExtensionFilter($any($event.target).value)"
							class="w-full px-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium uppercase tracking-wide text-peps-dark-200 outline-none focus:border-peps-gold/40 transition-colors duration-150 cursor-pointer"
						>
							<option value="">{{ 'page.marketplace.filter-all' | translate }}</option>
							@for (extension of extensions(); track extension.id) {
								<option [value]="extension.id">{{ extension.name }}</option>
							}
						</select>
					</div>

					<!-- Hide owned -->
					@if (authService.isAuthenticated()) {
						<div class="flex flex-col gap-1">
							<button
								class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
								[style.border-color]="hideOwnedFilter() ? '#EEC932' : 'rgba(255,255,255,0.07)'"
								[style.color]="hideOwnedFilter() ? '#EEC932' : 'rgba(255,255,255,0.3)'"
								[style.background]="hideOwnedFilter() ? 'rgba(238,201,50,0.12)' : 'transparent'"
								(click)="toggleHideOwnedFilter()"
								(keydown.enter)="toggleHideOwnedFilter()"
							>
								<span class="size-4 border flex items-center justify-center shrink-0"
								      [style.border-color]="hideOwnedFilter() ? '#EEC932' : 'rgba(255,255,255,0.3)'">
									@if (hideOwnedFilter()) {
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#EEC932" class="size-3">
											<path fill-rule="evenodd" d="M16.7 5.3a1 1 0 0 1 0 1.4l-8 8a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.4L8 12.6l7.3-7.3a1 1 0 0 1 1.4 0Z" clip-rule="evenodd" />
										</svg>
									}
								</span>
								<span class="flex-1">{{ 'page.marketplace.filter-hide-owned' | translate }}</span>
							</button>
						</div>
					}

					<!-- Rarity filters -->
					<div class="flex flex-col gap-1" data-tour="rarity-filter">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.marketplace.filter-rarity-label' | translate }}</span>
						<button
							class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
							[style.border-color]="rarityFilter() === null ? '#EEC932' : 'rgba(255,255,255,0.07)'"
							[style.color]="rarityFilter() === null ? '#EEC932' : 'rgba(255,255,255,0.3)'"
							[style.background]="rarityFilter() === null ? 'rgba(238,201,50,0.12)' : 'transparent'"
							(click)="setRarityFilter(null)"
							(keydown.enter)="setRarityFilter(null)"
						>
							<span class="size-2 lg:size-2.5 rounded-full shrink-0" style="background: #EEC932"></span>
							<span class="flex-1">{{ 'page.marketplace.filter-all' | translate }}</span>
						</button>
						@for (r of rarityOptions; track r.key) {
							<button
								class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
								[style.border-color]="rarityFilter() === r.key ? r.color : 'rgba(255,255,255,0.07)'"
								[style.color]="rarityFilter() === r.key ? r.color : 'rgba(255,255,255,0.3)'"
								[style.background]="rarityFilter() === r.key ? r.bg : 'transparent'"
								(click)="setRarityFilter(r.key)"
								(keydown.enter)="setRarityFilter(r.key)"
							>
								<span class="size-2 lg:size-2.5 rounded-full shrink-0" [style.background]="r.color"></span>
								<span class="flex-1">{{ r.labelKey | translate }}</span>
							</button>
						}
					</div>
				} @else if (activeTab() === 'mine') {
					<!-- Status filters (mine) -->
					<div class="flex flex-col gap-1">
						<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.marketplace.mine.status-label' | translate }}</span>
						@for (s of mineStatusOptions; track s.key) {
							<button
								class="flex items-center gap-2.5 px-3 py-2.5 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
								[style.border-color]="mineStatus() === s.key ? '#EEC932' : 'rgba(255,255,255,0.07)'"
								[style.color]="mineStatus() === s.key ? '#EEC932' : 'rgba(255,255,255,0.3)'"
								[style.background]="mineStatus() === s.key ? 'rgba(238,201,50,0.12)' : 'transparent'"
								(click)="setMineStatus(s.key)"
								(keydown.enter)="setMineStatus(s.key)"
							>
								<span class="flex-1">{{ s.labelKey | translate }}</span>
							</button>
						}
					</div>
				} @else if (activeTab() === 'history') {
					<!-- Récapitulatif des ventes -->
					<div class="flex flex-col gap-3">
						<div class="border border-peps-dark-500 px-3 py-3 flex flex-col gap-1" style="background: rgba(255,255,255,0.015);">
							<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em]">{{ 'page.marketplace.history.total-earned' | translate }}</span>
							<div class="flex items-baseline gap-1">
								<span class="text-2xl font-dinpro-bold text-peps-gold leading-none">{{ salesTotalEarned() }}</span>
								<span class="text-sm uppercase tracking-widest text-peps-gold/40 leading-none">PepsCoins</span>
							</div>
						</div>
						<span class="text-sm uppercase font-dinpro-medium text-peps-dark-200/40 tracking-wider">{{ 'page.marketplace.history.count' | translate:{ count: salesCount() } }}</span>
					</div>
				}
			</div>

			<!-- Listings grid -->
			<div class="flex-1 min-w-0">
				@if (isGridLoading()) {
					<div class="flex items-center justify-center py-24">
						<span class="inline-block w-8 h-8 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
					</div>
				} @else if (filteredListings().length) {
					<div class="flex flex-row flex-wrap gap-8 justify-center md:justify-start">
						@for (listing of filteredListings(); track listing.id) {
							<div
								class="flex flex-col cursor-pointer w-[182px] lg:w-[266px]"
								[attr.data-tour]="isDemoListing(listing) ? 'demo-card' : null"
								(click)="openCardDetail(listing)"
								(keydown.enter)="openCardDetail(listing)"
							>

								<!-- Card -->
								<div class="relative w-[182px] h-[266.5px] lg:w-[266px] lg:h-[389.5px]">
									<div class="origin-top-left scale-[0.65] lg:scale-[0.95]">
										<app-card
											[rarity]="listing.card.rarity"
											[name]="listing.card.name"
											[score]="listing.score"
											[rating]="listing.card.rating"
											[image]="listing.card.fileName"
											[extensionId]="listing.card.extension.id"
											[author]="listing.card.author"
										/>
									</div>
									@if (isDemoListing(listing)) {
										<div class="absolute top-1.5 left-1.5 z-10 text-[10px] uppercase tracking-widest font-dinpro-bold px-2 py-0.5 bg-peps-gold text-peps-dark-700">
											{{ 'page.marketplace.tutorial.demo-badge' | translate }}
										</div>
									}
									@if (listing.status !== 'ACTIVE') {
										<div class="absolute inset-0 flex items-center justify-center bg-black/55">
											<span
												class="text-sm lg:text-base uppercase tracking-widest font-dinpro-bold px-3 py-1 border"
												[class.text-emerald-400]="listing.status === 'SOLD'"
												[class.border-emerald-400]="listing.status === 'SOLD'"
												[class.text-red-400]="listing.status === 'CANCELLED'"
												[class.border-red-400]="listing.status === 'CANCELLED'"
											>
												{{ (listing.status === 'SOLD' ? 'page.marketplace.mine.status-sold' : 'page.marketplace.mine.status-cancelled') | translate }}
											</span>
										</div>
									}
								</div>

								<!-- Info panel -->
								<div class="border border-t-0 border-peps-dark-500 px-3.5 py-3 flex flex-col gap-2.5" style="background: rgba(255,255,255,0.015);">

									<!-- Seller -->
									<div class="flex items-center gap-1.5 min-w-0">
										<a
											[routerLink]="['/profil', listing.seller.username]"
											(click)="$event.stopPropagation()"
											class="group flex items-center gap-1.5 min-w-0 flex-1 cursor-pointer"
										>
											<img [src]="listing.seller.picture" class="size-5 lg:size-6 rounded-full object-cover bg-peps-dark-600 shrink-0 ring-1 ring-transparent group-hover:ring-peps-gold/50 transition-colors" alt="" />
											<span class="text-sm lg:text-base uppercase text-peps-gold/60 truncate font-notosans underline decoration-peps-gold/20 decoration-dotted underline-offset-4 group-hover:text-peps-gold group-hover:decoration-peps-gold/60 transition-colors">{{ listing.seller.username }}</span>
										</a>
										<div class="flex items-center gap-1">
											<span class="text-xl lg:text-2xl font-dinpro-bold text-peps-gold leading-none">{{ listing.price }}</span>
											<img src="assets/images/pepscoins.png" alt="" class="w-6 h-6">
										</div>
									</div>

									@if (listing.status === 'ACTIVE' && isOwnListing(listing)) {
										<div class="flex w-full gap-1.5">
											<button
												class="w-1/2 text-xs lg:text-sm uppercase tracking-wide px-2.5 py-1 border border-peps-gold/20 text-peps-gold/50 hover:border-peps-gold/50 hover:text-peps-gold transition-colors cursor-pointer"
												(click)="$event.stopPropagation(); openEditPriceModal(listing)"
												(keydown.enter)="$event.stopPropagation(); openEditPriceModal(listing)"
											>
												{{ 'page.marketplace.listing.edit-price' | translate }}
											</button>
											<button
												class="w-1/2 text-xs lg:text-sm uppercase tracking-wide px-2.5 py-1 border border-red-400/20 text-red-400/50 hover:border-red-400/50 hover:text-red-400 transition-colors cursor-pointer"
												(click)="$event.stopPropagation(); cancelListing(listing)"
												(keydown.enter)="$event.stopPropagation(); cancelListing(listing)"
											>
												{{ 'page.marketplace.listing.cancel' | translate }}
											</button>
										</div>
									}
								</div>
							</div>
						}
					</div>

					@if (hasMore()) {
						<div #loadMoreAnchor class="flex justify-center items-center mt-10 h-10" aria-hidden="true">
							@if (isLoadingMore()) {
								<span class="inline-block w-5 h-5 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
							}
						</div>
					}
				} @else if (visibleListings().length) {
					<div class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-10 lg:size-11 text-peps-dark-200/20">
							<path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
						</svg>
						<span class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.marketplace.no-filter-results' | translate }}</span>
					</div>
				} @else {
					<div class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-10 lg:size-11 text-peps-dark-200/20">
							<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 1 .75.75V21H6v-2.25a.75.75 0 0 1 .75-.75Z" />
						</svg>
						<span class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ (activeTab() === 'history' ? 'page.marketplace.history.empty' : 'page.marketplace.no-listings') | translate }}</span>
					</div>
				}
			</div>
		</div>
	</div>
}

<!-- ── Card detail modal (carte en grand + historique des prix + achat) ── -->
@if (selectedListing(); as listing) {
	<div @fadeInOut class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto py-10 bg-black/60 backdrop-blur-sm" (click)="onCardDetailBackdrop($event)">

		<button
			class="fixed top-6 right-6 z-10 text-peps-dark-200/50 hover:text-white transition-colors duration-200 cursor-pointer"
			(click)="closeCardDetail()"
			(keydown.enter)="closeCardDetail()"
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8 lg:size-9">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
			</svg>
		</button>

		<div @scaleInOut class="bg-peps-dark-800 border border-peps-dark-500 p-6 md:p-8 w-full max-w-4xl mx-4 flex flex-col md:flex-row gap-8">

			<!-- Carte en grand -->
			<div class="flex justify-center md:block shrink-0">
				<div class="relative w-[210px] h-[307.5px] lg:w-[364px] lg:h-[533px]">
					<div class="origin-top-left scale-[0.75] lg:scale-[1.3]">
						<app-card
							[rarity]="listing.card.rarity"
							[name]="listing.card.name"
							[score]="listing.score"
							[rating]="listing.card.rating"
							[image]="listing.card.fileName"
							[extensionId]="listing.card.extension.id"
							[interactive]="false"
							[staticDisplay]="true"
							[author]="listing.card.author"
						/>
					</div>
				</div>
			</div>

			<!-- Détail + historique + achat -->
			<div class="flex flex-col gap-5 flex-1 min-w-0 mt-6 md:mt-0">

				<div>
					<span class="text-xs lg:text-sm uppercase tracking-[0.3em] font-dinpro-medium text-peps-gold/40">{{ 'page.marketplace.subtitle' | translate }}</span>
					<h2 class="text-3xl md:text-5xl font-dinpro-bold uppercase text-white mt-0.5">{{ listing.card.name }}</h2>
					<a [routerLink]="['/profil', listing.seller.username]" class="group flex items-center gap-1.5 mt-1.5 w-fit cursor-pointer">
						<img [src]="listing.seller.picture" class="size-5 lg:size-6 rounded-full object-cover bg-peps-dark-600 ring-1 ring-transparent group-hover:ring-peps-gold/50 transition-colors" alt="" />
						<span class="text-base lg:text-lg uppercase text-peps-gold/60 font-notosans underline decoration-peps-gold/20 decoration-dotted underline-offset-4 group-hover:text-peps-gold group-hover:decoration-peps-gold/60 transition-colors">{{ listing.seller.username }}</span>
					</a>
				</div>

				<!-- Historique des prix -->
				<div class="flex flex-col gap-2">
					<span class="text-xs lg:text-sm uppercase tracking-[0.2em] font-dinpro-medium text-peps-dark-200/30">{{ 'page.marketplace.detail.price-history' | translate }}</span>
					@if (isSalesLoading()) {
						<div class="flex items-center justify-center py-10">
							<span class="inline-block w-6 h-6 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
						</div>
					} @else if (salesNotFound()) {
						<div class="border border-dashed border-peps-dark-500 py-6 flex items-center justify-center">
							<span class="text-sm lg:text-base uppercase tracking-wider text-peps-dark-200/30">{{ 'page.marketplace.detail.card-not-found' | translate }}</span>
						</div>
					} @else {
						<peps-price-history-chart [sales]="cardSales()" />
					}
				</div>

				<!-- Achat -->
				@if (listing.status === 'ACTIVE') {
					<div class="mt-auto flex flex-col gap-3 pt-3 border-t border-peps-dark-500">
						<div class="flex items-center justify-between">
							<span class="text-base lg:text-lg uppercase tracking-wider text-peps-dark-200/30">{{ 'page.marketplace.detail.price' | translate }}</span>
							<div class="flex items-center gap-1">
								<span class="text-xl lg:text-2xl font-dinpro-bold text-peps-gold leading-none">{{ listing.price }}</span>
								<img src="assets/images/pepscoins.png" alt="" class="w-6 h-6">
							</div>
						</div>

						@if (isOwnListing(listing)) {
							<span class="text-sm lg:text-base uppercase tracking-wider text-peps-dark-200/30 text-center py-2">{{ 'page.marketplace.listing.own-badge' | translate }}</span>
						} @else if (authService.isAuthenticated()) {
							<div class="flex items-center justify-between text-base lg:text-lg">
								<span class="uppercase tracking-wider text-peps-dark-200/30">{{ 'page.marketplace.buy-modal.balance-after' | translate }}</span>
								<span
									class="font-dinpro-bold text-lg lg:text-xl"
									[class.text-peps-gold]="(user()?.coins ?? 0) >= listing.price"
									[class.text-red-400]="(user()?.coins ?? 0) < listing.price"
								>{{ (user()?.coins ?? 0) - listing.price }}</span>
							</div>
							<button
								class="text-base lg:text-lg uppercase tracking-wider px-4 py-2.5 border transition-colors flex items-center justify-center"
								[ngClass]="canAfford(listing) && !isPurchasing() ? 'border-peps-gold/40 text-peps-gold hover:bg-peps-gold/10 cursor-pointer' : 'border-peps-dark-500 text-peps-dark-200/30 cursor-not-allowed'"
								[disabled]="!canAfford(listing) || isPurchasing()"
								(click)="confirmBuy()"
								(keydown.enter)="confirmBuy()"
							>
								@if (isPurchasing()) {
									<span class="inline-block w-4 h-4 border-2 border-peps-gold/50 border-t-transparent rounded-full animate-spin"></span>
								} @else {
									{{ 'page.marketplace.buy-modal.confirm' | translate }}
								}
							</button>
						}
					</div>
				}
			</div>
		</div>
	</div>
}

<!-- ── Sell modal ── -->
@if (showSellModal()) {
	<div @fadeInOut class="fixed inset-0 z-50 flex items-center justify-center max-md:p-0" (click)="onSellModalBackdrop($event)">
		<!-- Firefox : le flou doit être sur un calque frère (pas un ancêtre) du contenu,
		     sinon les <input> à l'intérieur ne prennent pas le focus au clic. -->
		<div class="absolute inset-0 bg-black/60 backdrop-blur-sm pointer-events-none" aria-hidden="true"></div>
		<div @scaleInOut class="relative bg-peps-dark-800 border border-peps-dark-500 p-6 md:p-10 w-full max-w-4xl md:max-w-[98vw] xl:max-w-[1900px] mx-4 flex flex-col gap-5 md:gap-6 h-[94vh] md:h-[95vh] max-h-[97vh] max-md:fixed max-md:inset-0 max-md:m-0 max-md:w-full max-md:max-w-none max-md:h-full max-md:max-h-none max-md:rounded-none max-md:border-0 max-md:overflow-y-auto">

			<!-- Header -->
			<div class="flex items-start justify-between">
				<div>
					<span class="text-xs lg:text-sm uppercase tracking-[0.3em] font-dinpro-medium text-peps-gold/40">{{ 'page.marketplace.subtitle' | translate }}</span>
					<h2 class="text-3xl md:text-5xl font-dinpro-bold uppercase text-white mt-0.5">{{ 'page.marketplace.sell-modal.title' | translate }}</h2>
				</div>
				<button class="text-peps-dark-200/30 hover:text-peps-dark-200/70 transition-colors p-1 cursor-pointer" (click)="closeSellModal()" (keydown.enter)="closeSellModal()">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 lg:size-6">
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
					</svg>
				</button>
			</div>

			<!-- Card selector -->
			<div class="flex flex-col gap-2 min-h-0 flex-1">
				<span class="text-xs lg:text-sm uppercase tracking-[0.2em] font-dinpro-medium text-peps-dark-200/30">{{ 'page.marketplace.sell-modal.select-card' | translate }}</span>

				<div class="relative flex items-center max-w-xs">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
						class="absolute left-3 size-4 lg:size-5 text-peps-dark-200/30 pointer-events-none">
						<path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
					</svg>
					<input
						type="text"
						[placeholder]="'page.marketplace.sell-modal.search-placeholder' | translate"
						[value]="sellCardNameFilter()"
						(input)="onSellCardNameInput($event)"
						class="w-full pl-9 pr-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium uppercase tracking-wide text-peps-dark-200 placeholder:text-peps-dark-200/30 outline-none focus:border-peps-gold/40 transition-colors duration-150"
					/>
				</div>

				@if (isSellableLoading() && !sellableCards().length) {
					<div class="flex items-center justify-center py-24">
						<span class="inline-block w-8 h-8 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
					</div>
				} @else if (sellableCards().length) {
					<div class="overflow-y-auto min-h-0 flex-1 pr-1 custom-scrollbar">
						<div class="flex flex-row flex-wrap gap-3 md:gap-4 justify-center py-8">
							@for (entry of sellableCards(); track entry.userCardId) {
								<div
									class="flex flex-col items-center cursor-pointer transition-all duration-150"
									(click)="selectInventoryCard(entry)"
									(keydown.enter)="selectInventoryCard(entry)"
								>
									<div class="relative w-[126px] h-[184.5px] lg:w-[174px] lg:h-[254px]">
										<div class="origin-top-left scale-[0.45] lg:scale-[0.62]">
											<app-card
												[rarity]="entry.card.rarity"
												[name]="entry.card.name"
												[score]="entry.score"
												[rating]="entry.card.rating"
												[image]="entry.card.fileName"
												[extensionId]="entry.card.extension.id"
												[author]="entry.card.author"
											/>
										</div>
										@if (selectedInventoryCard()?.userCardId === entry.userCardId) {
											<div class="absolute -top-1.5 -right-1.5 z-10 size-5 lg:size-6 rounded-full bg-peps-gold flex items-center justify-center shadow-md">
												<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="#1a1a1a" class="size-3 lg:size-3.5">
													<path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
												</svg>
											</div>
										}
									</div>
									@if (entry.sellableQuantity > 1) {
										<span class="text-xs lg:text-sm uppercase tracking-wide text-peps-gold/50 font-dinpro-medium">×{{ entry.sellableQuantity }}</span>
									}
								</div>
							}
						</div>
					</div>
					@if (sellableTotalPages() > 1) {
						<peps-page-selector
							[page]="sellablePage()"
							[totalPages]="sellableTotalPages()"
							(pageChange)="onSellablePageChange($event)"
							[goToTop]="false"
						></peps-page-selector>
					}
				} @else {
					<div class="border border-peps-dark-500 border-dashed py-10 flex items-center justify-center">
						<span class="text-sm lg:text-base uppercase tracking-wider text-peps-dark-200/30">
							{{ (sellCardNameFilter().trim() ? 'page.marketplace.sell-modal.no-search-results' : 'page.marketplace.sell-modal.no-cards') | translate }}
						</span>
					</div>
				}
			</div>

			<!-- Price input -->
			@if (selectedInventoryCard()) {
				<div class="flex flex-col gap-2">
					<span class="text-xs lg:text-sm uppercase tracking-[0.2em] font-dinpro-medium text-peps-dark-200/30">{{ 'page.marketplace.sell-modal.price' | translate }}</span>
					<div class="flex items-center gap-3">
						<input
							type="number"
							min="1"
							[value]="listingPrice()"
							(input)="listingPrice.set(+$any($event.target).value)"
							class="w-32 px-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-lg lg:text-xl font-dinpro-medium text-peps-dark-200 outline-none focus:border-peps-gold/40 transition-colors tabular-nums"
						/>
						<span class="text-lg lg:text-xl uppercase tracking-widest text-peps-gold/50">PEPSCOINS</span>
					</div>
				</div>
			}

			<!-- Footer -->
			<div class="flex gap-3 justify-end pt-2 border-t border-peps-dark-500">
				<button
					class="text-sm lg:text-base uppercase tracking-wider text-peps-dark-200/40 hover:text-peps-dark-200/70 transition-colors px-3 py-2 cursor-pointer"
					(click)="closeSellModal()"
					(keydown.enter)="closeSellModal()"
					[disabled]="isListing()"
				>
					{{ 'page.marketplace.sell-modal.cancel' | translate }}
				</button>
				<button
					class="text-sm lg:text-base uppercase tracking-wider px-4 py-2 border transition-colors min-w-[110px] flex items-center justify-center"
					[ngClass]="selectedInventoryCard() && listingPrice() > 0 && !isListing() ? 'border-peps-gold/40 text-peps-gold hover:bg-peps-gold/10 cursor-pointer' : 'border-peps-dark-500 text-peps-dark-200/30 cursor-not-allowed'"
					[disabled]="!selectedInventoryCard() || listingPrice() <= 0 || isListing()"
					(click)="confirmSell()"
					(keydown.enter)="confirmSell()"
				>
					@if (isListing()) {
						<span class="inline-block w-4 h-4 border-2 border-peps-gold/50 border-t-transparent rounded-full animate-spin"></span>
					} @else {
						{{ 'page.marketplace.sell-modal.confirm' | translate }}
					}
				</button>
			</div>
		</div>
	</div>
}

<!-- ── Edit price modal ── -->
@if (editPriceListing(); as listing) {
	<div @fadeInOut class="fixed inset-0 z-50 flex items-center justify-center p-4" (click)="onEditPriceBackdrop($event)">
		<!-- Firefox : flou sur un calque frère, pas un ancêtre du contenu (focus des <input>). -->
		<div class="absolute inset-0 bg-black/60 backdrop-blur-sm pointer-events-none" aria-hidden="true"></div>
		<div @scaleInOut class="relative bg-peps-dark-800 border border-peps-dark-500 p-6 md:p-8 w-full max-w-md flex flex-col gap-5">

			<!-- Header -->
			<div class="flex items-start justify-between">
				<div>
					<span class="text-xs lg:text-sm uppercase tracking-[0.3em] font-dinpro-medium text-peps-gold/40">{{ 'page.marketplace.subtitle' | translate }}</span>
					<h2 class="text-2xl md:text-3xl font-dinpro-bold uppercase text-white mt-0.5">{{ 'page.marketplace.edit-price-modal.title' | translate }}</h2>
				</div>
				<button class="text-peps-dark-200/30 hover:text-peps-dark-200/70 transition-colors p-1 cursor-pointer" (click)="closeEditPriceModal()" (keydown.enter)="closeEditPriceModal()">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 lg:size-6">
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
					</svg>
				</button>
			</div>

			<div class="flex items-center gap-2 min-w-0">
				<span class="size-2.5 rounded-full shrink-0" [style.background]="rarityColor(listing.card.rarity)"></span>
				<span class="text-base lg:text-lg uppercase font-dinpro-medium tracking-wide text-white/80 truncate">{{ listing.card.name }}</span>
			</div>

			<!-- Price input -->
			<div class="flex flex-col gap-2">
				<span class="text-xs lg:text-sm uppercase tracking-[0.2em] font-dinpro-medium text-peps-dark-200/30">{{ 'page.marketplace.edit-price-modal.label' | translate }}</span>
				<div class="flex items-center gap-3">
					<input
						type="number"
						min="1"
						[value]="editPriceValue()"
						(input)="onEditPriceInput($event)"
						class="w-32 px-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-lg lg:text-xl font-dinpro-medium text-peps-dark-200 outline-none focus:border-peps-gold/40 transition-colors tabular-nums"
					/>
					<span class="text-lg lg:text-xl uppercase tracking-widest text-peps-gold/50">PEPSCOINS</span>
				</div>
			</div>

			<!-- Footer -->
			<div class="flex gap-3 justify-end pt-2 border-t border-peps-dark-500">
				<button
					class="text-sm lg:text-base uppercase tracking-wider text-peps-dark-200/40 hover:text-peps-dark-200/70 transition-colors px-3 py-2 cursor-pointer"
					(click)="closeEditPriceModal()"
					(keydown.enter)="closeEditPriceModal()"
					[disabled]="isUpdatingPrice()"
				>
					{{ 'page.marketplace.edit-price-modal.cancel' | translate }}
				</button>
				<button
					class="text-sm lg:text-base uppercase tracking-wider px-4 py-2 border transition-colors min-w-[110px] flex items-center justify-center"
					[ngClass]="editPriceValue() > 0 && !isUpdatingPrice() ? 'border-peps-gold/40 text-peps-gold hover:bg-peps-gold/10 cursor-pointer' : 'border-peps-dark-500 text-peps-dark-200/30 cursor-not-allowed'"
					[disabled]="editPriceValue() <= 0 || isUpdatingPrice()"
					(click)="confirmEditPrice()"
					(keydown.enter)="confirmEditPrice()"
				>
					@if (isUpdatingPrice()) {
						<span class="inline-block w-4 h-4 border-2 border-peps-gold/50 border-t-transparent rounded-full animate-spin"></span>
					} @else {
						{{ 'page.marketplace.edit-price-modal.confirm' | translate }}
					}
				</button>
			</div>
		</div>
	</div>
}
